module.exports = __webpack_public_path__ + "assets/img/jtfx53.4b56a044.jpg";